export class TimeHelper {
	getMsFromSeconds(seconds: number): number {
		return seconds * 1000;
	}
}

export const timeHelper = new TimeHelper();
